import { render } from "./PortfolioComponent.vue?vue&type=template&id=035b735a&scoped=true"
import script from "./PortfolioComponent.vue?vue&type=script&lang=js"
export * from "./PortfolioComponent.vue?vue&type=script&lang=js"

import "./PortfolioComponent.vue?vue&type=style&index=0&id=035b735a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035b735a"]])

export default __exports__